export const FEATURE_CUSTOM_REDUX = "feature/customise/app";
export const FEATURE_CUSTOM_REDUX_V2 = "feature/customise/app/v2";
export const FEATURE_CUSTOM_REDUX_V3 = "feature/customise/app/v3";
export const FEATURE_CUSTOM_PAYMENT = "feature/customise/payment";
export const FEATURE_CUSTOM_REDUX_V4 = "feature/customise/app/v4";


export const API_STUDENT_WAIT_INTERVAL = 5000;

export const BUFFER_USER = {
        HOST: "HOST",
        PARTICIPANT: "PARTICIPANT",
};

const DEEPLINKING = {
        rta: {
                android: {
                        link: "https://play.google.com/store/apps/details?id=com.trmc.webjams",
                        key: "com.trmc.webjams"
                },
                ios: {
                        link: "https://apps.apple.com/in/app/webjam/id1536373788",
                        key: "de.hoppJitsimeetVideo",
                        id: "id1536373788"
                },
                shortLink: "https://webjam.page.link"
                // shortLink : "https://rtaweb.page.link"
        },
        duet: {
                // https://webjam.page.link
                android: {
                        link: "",
                        key: ""
                },
                ios: {
                        link: "",
                        key: ""
                },
                shortLink: ""
        },
        trmc: {
                android: {
                        link: "https://play.google.com/store/apps/details?id=com.trmc.live",
                        key: "com.trmc.live"
                },
                ios: {
                        link: "https://apps.apple.com/us/app/trmc-live/id1507184060",
                        key: "com.TRMC.app",
                        id: "id1507184060"
                },
                shortLink: "https://trmc.page.link"
        },
        mms: {
                android: {
                        link: "https://play.google.com/store/apps/details?id=com.mms.webjams",
                        key: "com.mms.webjams"
                },
                ios: {
                        link: "https://apps.apple.com/in/app/webjam/id1595532404",
                        key: "com.mms.webjams",
                        id: "id1595532404"
                },
                shortLink: "https://matchmysound.page.link"
        }
}

export const THEME_HASH = {
        rta: "bbf5f25abf74a0e64a6fe2f281c1a30a",
        duet: "afb5b5e637056767a633f49e71a79873",
        mms: "d55977c223a588fdc11aff690a068b03",
        trmc: "d123d533151c9e04bb254394bfb4bac2"
}


export const BASE_CONFIG = {
        "default": { // Default

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio device. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio device.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social-rta.staging02.com/webcam",
                dashboardReferrerUrl: "https://social-rta.staging02.com/dashboard",
                appReferrerUrl: "https://uat.realtimeaudio.com",
                socialBaseUrl: "https://social-rta.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: true,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: false, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                sendAnalytics: false,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                calculateDevicePing: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: true,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: true,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms.
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: true, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: true, // to show current url is opening in iframe 
                webViewApp: true, // To enable/disable web view application functionality
        },
        "https://uat.realtimeaudio.com": { // RTA UAT staging

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio device. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio device.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social-rta.staging02.com/webcam",
                dashboardReferrerUrl: "https://social-rta.staging02.com/dashboard",
                appReferrerUrl: "https://uat.realtimeaudio.com",
                socialBaseUrl: "https://social-rta.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: false, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: true, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                sendAnalytics: false,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                calculateDevicePing: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: true,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: true,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms.
                showSoftwareVersion: true, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: true, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: true, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://web.realtimeaudio.com": { // RTA Live

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio device. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio device.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid-live',
                serverVarRecordingStreaming: 'avstack-recording-live',
                FbPostUrl: 'https://share.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://share.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social.realtimeaudio.com/webcam",
                dashboardReferrerUrl: "https://social.realtimeaudio.com/dashboard",
                appReferrerUrl: "https://web.realtimeaudio.com",
                socialBaseUrl: "https://social.realtimeaudio.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "UA-221894036-1",
                apiVersion: "/v3",

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: false, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: true, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: true,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                sendAnalytics: true,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                calculateDevicePing: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: true,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: true,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: true, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: true, // to show current url is opening in iframe
                webViewApp: true, // To enable/disable web view application functionality
        },
        "https://social.realtimeaudio.com": { // RTA Social Live

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio device. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio device.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid-live',
                serverVarRecordingStreaming: 'avstack-recording-live',
                FbPostUrl: 'https://share.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://share.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social.realtimeaudio.com/webcam",
                dashboardReferrerUrl: "https://social.realtimeaudio.com/dashboard",
                appReferrerUrl: "https://web.realtimeaudio.com",
                socialBaseUrl: "https://social.realtimeaudio.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "UA-221894036-1",
                apiVersion: "/v3",

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: false, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: true,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                sendAnalytics: true,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                calculateDevicePing: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: true,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: true,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: true, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: true, // to show current url is opening in iframe
                webViewApp: true, // To enable/disable web view application functionality
        },
        "https://duet-staging.realtimeaudio.com": { // DUET staging

                // Themes
                themeNameHash: THEME_HASH.duet,
                themeName: "duet",
                themePrimaryColor: "5535a9",
                mixerImage: "polygon",
                lightingIcon: "duet",
                themeFontFamily: "",

                // Text & Messages
                name: "Duet",
                sideBarTitle: "Duet",
                title: "Duet",
                userName: "Duet User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "Duet",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "Welcome to Duet",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_duet_logo_white.png",
                loginLogo: "images/logo/duet-login-logo.png",
                smallLogo: "images/logo/duet_small_logo.png",
                favicon: "images/logo/duet_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/duet_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "images/logo/welcome_duet_logo_white.png",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://recordings.duetpartner.com',
                PostUrl: 'https://duetpartner.com',
                recordingUrl: "https://recordings.duetpartner.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "tools", "manageHostTab", "hybridMode", "delayPanning", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", "myRecordings", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: false,
                showShareFiles: false,
                isExploreOpen: true,
                isSubToolsOpen: true,
                isAudioToolsOpen: true,
                menuLogoShow: true,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: false,
                paidLecture: false,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.duet,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: true,
                deviceHelp: false,
                welcomeTitle: false,
                roomEnter: false,
                lobbyChange: true,
                profileNameEdit: false,
                calenderShow: false,
                filterToolBar: false,
                inviteButton: false,
                embedmeeting: false,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: false,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://live.duetpartner.com": { // DUET live

                // Themes
                themeNameHash: THEME_HASH.duet,
                themeName: "duet",
                themePrimaryColor: "5535a9",
                mixerImage: "polygon",
                lightingIcon: "duet",
                themeFontFamily: "",

                // Text & Messages
                name: "Duet",
                sideBarTitle: "Duet",
                title: "Duet",
                userName: "Duet User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "Duet",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "Welcome to Duet",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_duet_logo_white.png",
                loginLogo: "images/logo/duet-login-logo.png",
                smallLogo: "images/logo/duet_small_logo.png",
                favicon: "images/logo/duet_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/duet_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "images/logo/welcome_duet_logo_white.png",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid-live',
                serverVarRecordingStreaming: 'avstack-recording-live',
                FbPostUrl: 'https://recordings.duetpartner.com',
                PostUrl: 'https://duetpartner.com',
                recordingUrl: "https://recordings.duetpartner.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "tools", "manageHostTab", "hybridMode", "delayPanning", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", "myRecordings", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: true,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: false,
                showShareFiles: false,
                isExploreOpen: true,
                isSubToolsOpen: true,
                isAudioToolsOpen: true,
                menuLogoShow: true,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: false,
                paidLecture: false,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.duet,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: true,
                deviceHelp: false,
                welcomeTitle: false,
                roomEnter: false,
                lobbyChange: true,
                profileNameEdit: false,
                calenderShow: false,
                filterToolBar: false,
                inviteButton: false,
                embedmeeting: false,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: false,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms.
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://trmcuat.oneclickwebcam.com": { // TRMC staging

                // Themes
                themeNameHash: THEME_HASH.trmc,
                themeName: "trmc",
                themePrimaryColor: "35aef7",
                mixerImage: "polygon",
                lightingIcon: "trmc",
                themeFontFamily: "",

                // Text & Messages
                name: "TRMC",
                sideBarTitle: "Taylor Robinson <span>Music Live</span>",
                title: "TRMC",
                userName: "TRMC User",
                boxPairTitle: "Pair RealTime Audio box",
                boxUnPairTitle: "Unpair RealTime Audio box",
                deviceListTitle: " We detected a RealTime Audio box. <br />  Please select your device ID. ",
                deviceListSearch: "Searching for a RealTime Audio box...",
                deviceListSearchFailed: "We did not detect a RealTime Audio box. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio box? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio box.",
                webJamConnected: "You are now connected with a RealTime Audio box and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio box. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio box.`,
                manageHostServerName: "TRMC",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/trmc-watermark.svg",
                loginLogo: "images/logo/trmc-login-logo.png",
                smallLogo: "images/logo/trmc-small-logo.png",
                favicon: "images/logo/trmc-favicon.ico",
                settingsImage: "images/logo/trmc_settings.png",
                starIcon: "images/logo/trmc_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://trmcuatshare.oneclickwebcam.com',
                PostUrl: 'http://taylorrobinsonmusic.com',
                recordingUrl: "https://trmcuatshare.oneclickwebcam.com",
                pianoUrl: "https://piano.realtimeaudio.com",
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "embedCode", "claimRoom", "explore", "login", "tools", "manageHostTab", "hybridMode", "delayPanning", "addParticipant", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "whiteboard"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: false,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,
                confirmUserToAutoHost: false,
                detectRecommendedHost: false,
                saveDeviceConnectSession: false,
                prejoinWithoutMic: false,
                canAllUserMakeHost: false,
                moderatorCanMakeHost: false,
                monitorHostTabChange: false,

                // Login & Deeplinking
                login: true,
                paidLecture: false,
                guestUser: true,
                deeplinking: true,
                deeplinkingLink: DEEPLINKING.trmc,

                // Recording & Streaming & Jitter Buffer
                stemRecording: false,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: true,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://web.oneclickwebcam.com": { // TRMC Live

                // Themes
                themeNameHash: THEME_HASH.trmc,
                themeName: "trmc",
                themePrimaryColor: "35aef7",
                mixerImage: "polygon",
                lightingIcon: "trmc",
                themeFontFamily: "",

                // Text & Messages
                name: "TRMC",
                sideBarTitle: "Taylor Robinson <span>Music Live</span>",
                title: "TRMC",
                userName: "TRMC User",
                boxPairTitle: "Pair RealTime Audio box",
                boxUnPairTitle: "Unpair RealTime Audio box",
                deviceListTitle: " We detected a RealTime Audio box. <br />  Please select your device ID. ",
                deviceListSearch: "Searching for a RealTime Audio box...",
                deviceListSearchFailed: "We did not detect a RealTime Audio box. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio box? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio box.",
                webJamConnected: "You are now connected with a RealTime Audio box and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We are not able to automatically connect to your RealTime Audio box. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio box.`,
                manageHostServerName: "TRMC",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/trmc-watermark.svg",
                loginLogo: "images/logo/trmc-login-logo.png",
                smallLogo: "images/logo/trmc-small-logo.png",
                favicon: "images/logo/trmc-favicon.ico",
                settingsImage: "images/logo/trmc_settings.png",
                starIcon: "images/logo/trmc_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid-live',
                serverVarRecordingStreaming: 'avstack-recording-live',
                FbPostUrl: 'https://share.oneclickwebcam.com',
                PostUrl: 'http://taylorrobinsonmusic.com',
                recordingUrl: "https://share.oneclickwebcam.com",
                pianoUrl: "https://piano.realtimeaudio.com",
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "embedCode", "claimRoom", "explore", "login", "tools", "manageHostTab", "hybridMode", "delayPanning", "addParticipant", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "whiteboard"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: false,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,
                confirmUserToAutoHost: false,
                detectRecommendedHost: false,
                saveDeviceConnectSession: false,
                prejoinWithoutMic: false,
                canAllUserMakeHost: false,
                moderatorCanMakeHost: false,
                monitorHostTabChange: false,

                // Login & Deeplinking
                login: true,
                paidLecture: false,
                guestUser: true,
                deeplinking: true,
                deeplinkingLink: DEEPLINKING.trmc,

                // Recording & Streaming & Jitter Buffer
                stemRecording: false,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: true,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://mmsuat.realtimeaudio.com": { // MMS staging

                // Themes
                themeNameHash: THEME_HASH.mms,
                themeName: "mms",
                themePrimaryColor: "35609D",
                mixerImage: "square",
                lightingIcon: "mms",
                themeFontFamily: "Nunito Sans",

                // Text & Messages
                name: "MMS",
                sideBarTitle: "MMS",
                title: "MatchMySound",
                userName: "MMS User",
                boxPairTitle: "Pair box",
                boxUnPairTitle: "Unpair box",
                deviceListTitle: "We detected a box. <br> Please select your device ID.",
                deviceListSearch: "Checking for the box...",
                deviceListSearchFailed: "We did not detect a box. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a box? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a box.",
                webJamConnected: "You are now connected with a device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your box. Please check your connection and then click the "Connect box" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "MMS",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_mms_watermark.svg",
                loginLogo: "images/logo/welcome_mms_logo_white.png",
                smallLogo: "images/logo/mms_small_logo.png",
                favicon: "images/logo/mms_favicon.ico",
                settingsImage: "images/logo/mms_settings.png",
                starIcon: "images/logo/mms_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "images/logo/mms_tool_logo.png",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "mmslivevideos",
                s3RecordingUrlLive: "mmslivevideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://mmsuatshare.realtimeaudio.com',
                PostUrl: 'https://matchmysound.com',
                recordingUrl: "https://mmsuatshare.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "embedCode", "claimRoom", "explore", "login", "tools", "manageHostTab", "hybridMode", "delayPanning", "addParticipant", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "whiteboard"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: false,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: false,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: false,
                showShareFiles: false,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: true,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: true,
                paidLecture: false,
                guestUser: true,
                deeplinking: true,
                deeplinkingLink: DEEPLINKING.mms,

                // Recording & Streaming & Jitter Buffer
                stemRecording: false,
                jitterBufferIP: ["showToAll"], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: false,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://live.matchmysound.com": { // MMS  Live

                // Themes
                themeNameHash: THEME_HASH.mms,
                themeName: "mms",
                themePrimaryColor: "35609D",
                mixerImage: "square",
                lightingIcon: "mms",
                themeFontFamily: "Nunito Sans",

                // Text & Messages
                name: "MMS",
                sideBarTitle: "MMS",
                title: "MatchMySound",
                userName: "MMS User",
                boxPairTitle: "Pair box",
                boxUnPairTitle: "Unpair box",
                deviceListTitle: "We detected a box. <br> Please select your device ID.",
                deviceListSearch: "Checking for the box...",
                deviceListSearchFailed: "We did not detect a box. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a box? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a box.",
                webJamConnected: "You are now connected with a device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your box. Please check your connection and then click the "Connect box" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "MMS",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_mms_watermark.svg",
                loginLogo: "images/logo/welcome_mms_logo_white.png",
                smallLogo: "images/logo/mms_small_logo.png",
                favicon: "images/logo/mms_favicon.ico",
                settingsImage: "images/logo/mms_settings.png",
                starIcon: "images/logo/mms_star.svg",
                socialWebLogo: "",
                socialWebLogoWhite: "",
                disabledLightingIcon: "images/logo/disabledlighting.png",
                socialWebIcon: "",
                socialWebIconBlack: "",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "",
                menuImg: "images/logo/mms_tool_logo.png",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "mmslivevideos",
                s3RecordingUrlLive: "mmslivevideos",
                serverVarInHybridsession: 'avstack-hybrid-live',
                serverVarRecordingStreaming: 'avstack-recording-live',
                FbPostUrl: 'https://mmshare.realtimeaudio.com',
                PostUrl: 'https://matchmysound.com',
                recordingUrl: "https://mmshare.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "",
                dashboardReferrerUrl: "",
                appReferrerUrl: "",
                socialBaseUrl: "",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "embedCode", "claimRoom", "explore", "login", "tools", "manageHostTab", "hybridMode", "delayPanning", "addParticipant", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "whiteboard"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: true,
                metronome: true,
                piano: true,
                scaleGenerator: true,
                drum: false,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: false,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: [],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: false,
                overlaySidebarMenuButton: false,
                showSignOutButton: false,
                showMenuList: false,
                showShareAudio: false,
                showShareFiles: false,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: true,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: true,
                showAllThirdPartyServers: false,

                // Login & Deeplinking
                login: true,
                paidLecture: false,
                guestUser: true,
                deeplinking: true,
                deeplinkingLink: DEEPLINKING.mms,

                // Recording & Streaming & Jitter Buffer
                stemRecording: false,
                jitterBufferIP: ["showToAll"], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: false,
                defaultTileView: true,
                customTutorial: false,
                saveUnClaimedRoom: false,
                showMuteDialog: false,
                roomOwnerReminderEmail: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://aayushhanda.staging02.com": { // Aayush domain for new jitsi version deployment

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social-rta.staging02.com/webcam",
                dashboardReferrerUrl: "https://social-rta.staging02.com/dashboard",
                appReferrerUrl: "https://aayushhanda.staging02.com",
                socialBaseUrl: "https://social-rta.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: true,
                showDevicePreJoining: true,
                prejoinBackButton: true,
                prejoinRedirectToSocialButton: true,
                calculateDevicePing: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: true, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: true,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: false,
                prejoinWithoutMic: false,
                canAllUserMakeHost: false,
                moderatorCanMakeHost: false,
                monitorHostTabChange: false,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://johnysharma.staging02.com": { // Staging recording domain for new jitsi version ghost entry

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // Arrays
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board"],
                jitterBufferIP: [], // To enable/disable jitter buffer
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],

                // URL's & Servers
                deeplinkingLink: DEEPLINKING.rta,
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social-rta.staging02.com/webcam",
                dashboardReferrerUrl: "https://social-rta.staging02.com/dashboard",
                appReferrerUrl: "https://aayushhanda.staging02.com",
                socialBaseUrl: "https://social-rta.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",

                // Tools
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: true,
                showDevicePreJoining: true,
                prejoinBackButton: true,
                prejoinRedirectToSocialButton: true,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Other Flags
                deeplinking: false,
                menuLogoShow: false,
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                stemRecording: true,
                filterToolBar: false,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                inviteButton: true,
                showShareAudio: true,
                showShareFiles: true,
                embedmeeting: true,
                sendAnalytics: false,
                lobbyChat: true,
                defaultTileView: true,
                login: false,
                paidLecture: false,
                guestUser: true,
                customTutorial: false,
                noChangedRoomName: true,
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link
                calculateDevicePing: false,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showHomePageHomeIcon: false,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                showSignOutButton: true,
                showMenuList: true,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showAllThirdPartyServers: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: false,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: false,
                canAllUserMakeHost: false,
                moderatorCanMakeHost: false,
                monitorHostTabChange: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                multiStream: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://recordings.realtimeaudio.com": { // Live recording domain for new jitsi version ghost entry

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // Arrays
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board"],
                jitterBufferIP: [], // To enable/disable jitter buffer
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],

                // URL's & Servers
                deeplinkingLink: DEEPLINKING.rta,
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://social-rta.staging02.com/webcam",
                dashboardReferrerUrl: "https://social-rta.staging02.com/dashboard",
                appReferrerUrl: "https://aayushhanda.staging02.com",
                socialBaseUrl: "https://social-rta.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",

                // Tools
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: false,
                isPaymentButtonDisabled: false, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: false,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                showPreJoiningInConference: false, // For device pre-joining inside conference
                noDevicePreJoiningScreen: false, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: false, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: false, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Other Flags
                deeplinking: false,
                menuLogoShow: false,
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                stemRecording: true,
                filterToolBar: false,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                inviteButton: true,
                showShareAudio: true,
                showShareFiles: true,
                embedmeeting: true,
                sendAnalytics: false,
                lobbyChat: true,
                defaultTileView: true,
                login: false,
                paidLecture: false,
                guestUser: true,
                customTutorial: false,
                noChangedRoomName: true,
                socialAllowed: false, // For restricting entry without social website login
                socialInvite: false, // For user entry with social website invite link
                calculateDevicePing: false,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showHomePageHomeIcon: false,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                showSignOutButton: true,
                showMenuList: true,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showAllThirdPartyServers: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: false,
                detectRecommendedHost: true,
                saveDeviceConnectSession: true,
                prejoinWithoutMic: false,
                canAllUserMakeHost: false,
                moderatorCanMakeHost: false,
                monitorHostTabChange: false,
                showE2eCheck: false,
                showRoomsListing: false,
                showLanguageDropdown: false,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                multiStream: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: false, // For new host hangup flow (move other participants to third party server) 
                checkNatType: false, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms.
                showSoftwareVersion: false, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://rtalocal.staging02.com:8080": { // RTA local domain for local testing

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://gursahib.staging02.com/webcam",
                dashboardReferrerUrl: "https://gursahib.staging02.com/dashboard",
                appReferrerUrl: "https://uat.realtimeaudio.com",
                socialBaseUrl: "https://gursahib.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: true,
                showDevicePreJoining: true,
                prejoinBackButton: true,
                prejoinRedirectToSocialButton: true,
                calculateDevicePing: true,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: false, // Hide pre-meeting screen
                hideAskSubscriptionModal: true, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: true, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: true,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: false,
                prejoinWithoutMic: false,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms. 
                showSoftwareVersion: true, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: false, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: false, // To enable/disable P2P mode
                allowIframeOpen: true, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        },
        "https://192.168.1.15:8080": { // Aayush local
                // "https://192.168.0.139:8080":  { // Mohit local
                // "https://192.168.0.148:8080": { // Aniket local 
                // "https://192.168.0.98:8080": { // Jashanpreet local
                // "https://192.168.1.7:8080": { // Ujjwal local

                // Themes
                themeNameHash: THEME_HASH.rta,
                themeName: "rta",
                themePrimaryColor: "31abb1",
                mixerImage: "polygon",
                lightingIcon: "rta",
                themeFontFamily: "",

                // Text & Messages
                name: "RTA",
                sideBarTitle: "RealTime Audio",
                title: "RealTime Audio",
                userName: "RTA User",
                boxPairTitle: "Connect RealTime Audio device",
                boxUnPairTitle: "Disconnect RealTime Audio device",
                deviceListTitle: "A RealTime Audio device has been found. <br /> Please use the connect button to connect this device.",
                deviceListSearch: "Searching for a RealTime Audio device...",
                deviceListSearchFailed: "We did not detect a RealTime Audio device. Without one, you will not be able to experience ultra-low latency.",
                skipDeviceConnect: "Don't have a RealTime Audio device? You can click \"Skip\" to enter without ultra-low latency audio.",
                purchaseBoxTitle: " to purchase a RealTime Audio device.",
                webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
                makeHostDisconnected: `We were not able to automatically connect your RealTime Audio device. Please check your connection and then click the "Connect RealTime Audio device" option by selecting the three-line menu at the top left corner.`,
                manageHostServerName: "RTA",
                deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
                deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
                siteTitle: "",

                // Logo & Images
                welcomeLogo: "images/logo/welcome_rta_logo_white.svg",
                loginLogo: "images/logo/rta-login-logo.png",
                smallLogo: "images/logo/rta_small_logo.png",
                favicon: "images/logo/rta_favicon.ico",
                settingsImage: "images/logo/all_settings.png",
                starIcon: "images/logo/rta_star.svg",
                socialWebLogo: "images/logo/social-web.png",
                socialWebLogoWhite: "images/logo/social-web-white.png",
                disabledLightingIcon: "images/logo/rtadisabledlighting.png",
                socialWebIcon: "/images/logo/social-web-dashboard.png",
                socialWebIconBlack: "/images/logo/social-web-dashboard-black.png",
                defaultUserImage: "/images/logo/Male-user-sm.png",
                homeIconPathImage: "/images/logo/hamburger-settings.png",
                menuImg: "",
                languageIcon: "/images/logo/language.png", // To change language icon

                // URL's & Servers
                s3RecordingUrlStaging: "rtauatshare",
                s3RecordingUrlLive: "rtastagingvideos",
                serverVarInHybridsession: 'avstack-hybrid',
                serverVarRecordingStreaming: 'avstack-recording',
                FbPostUrl: 'https://shareuat.realtimeaudio.com',
                PostUrl: 'https://realtimeaudio.com',
                recordingUrl: "https://shareuat.realtimeaudio.com",
                pianoUrl: 'https://piano.realtimeaudio.com',
                drumUrl: 'https://drum.realtimeaudio.com',
                whiteBoardUrl: 'https://whiteboard.oneclickwebcam.com',
                socialReferrerUrl: "https://gursahib.staging02.com/webcam",
                dashboardReferrerUrl: "https://gursahib.staging02.com/dashboard",
                appReferrerUrl: "https://uat.realtimeaudio.com",
                socialBaseUrl: "https://gursahib.staging02.com",
                drumSetUrl: 'https://drum-set.realtimeaudio.com',

                // Keys & API Versions & Analytics
                googleGAKey: "",
                apiVersion: "/v3",
                sendAnalytics: false,

                // Tools
                tools: ["mixer", "login", "claimRoom", "explore", "tools", "manageHostTab", "hybridMode", "delayPanning", "uploadWhiteboardMedia", "chordChart", "guitarTuner", "latencyMetronome", "metronome", "piano", "scaleGenerator", "drum", "whiteboard", 'myRecordings', "dashboard", "boxIndicator"],
                allowedToolSync: ["guitar-tuner", "box-metronome", "voice-chord", "guitar-scale", "piano", "drum", "white-board", "simple-whiteboard"],
                chordChart: true,
                guitarTuner: true,
                latencyMetronome: false,
                metronome: true,
                piano: false,
                scaleGenerator: true,
                drum: true,
                whiteboard: true,
                whiteboardScreenShot: true,
                audioShareTool: true,
                viewShortcuts: false,

                // Payment & Dashboard Subscription & Pre-Joining
                subscriptionRequired: true,
                isPaymentButtonDisabled: true, // Dashboard -> Subscription tab -> buttons
                showRoomDashboard: true,
                showPreJoining: false,
                prejoinLoginRequired: false,
                showDevicePreJoining: false,
                prejoinBackButton: false,
                prejoinRedirectToSocialButton: false,
                calculateDevicePing: true,
                showPreJoiningInConference: true, // For device pre-joining inside conference
                noDevicePreJoiningScreen: true, // For disabling device pre-joining on pre-meeting screen
                recheckConnectDevice: true, // To check pre-meeting flow was completed or not on connect device popup
                prejoinAutoConnect: true, // To automatically connect box after prejoin process is complete
                hidePreJoinScreen: true, // Hide pre-meeting screen
                hideAskSubscriptionModal: false, // if user have no subscription, then he try to (Create room, share invite links, speech translation, accept lobby person), then we showing a modal to buy subscription

                // Social RTA
                socialAllowed: true, // For restricting entry without social website login
                socialInvite: true, // For user entry with social website invite link

                // Sidebar & Sidebar Icon & Sidebar Conent & Side Dropdown
                sideBarMenuList: ["roomList", "myRecordings", "subscription", "paymentHistory", "rtaSocialNetwork"],
                showHomePageHomeIcon: false,
                sidebarProfileIcon: true,
                overlaySidebarMenuButton: true,
                showSignOutButton: true,
                showMenuList: true,
                showShareAudio: true,
                showShareFiles: true,
                isExploreOpen: false,
                isSubToolsOpen: false,
                isAudioToolsOpen: false,
                menuLogoShow: false,

                // Manage Host
                noChangedRoomName: true,
                selectAutoHostCheckbox: false,
                makeHostChangeRoom: false,
                showAllThirdPartyServers: true,

                // Login & Deeplinking
                login: true,
                paidLecture: true,
                guestUser: false,
                deeplinking: false,
                deeplinkingLink: DEEPLINKING.rta,

                // Recording & Streaming & Jitter Buffer
                stemRecording: true,
                jitterBufferIP: [], // To enable/disable jitter buffer
                streamingPlatforms: ['youtube', 'tiktok', 'facebook'],
                multiStream: true,

                // Other Flags
                willAuthorize: false,
                deviceHelp: true,
                welcomeTitle: true,
                roomEnter: true,
                lobbyChange: true,
                profileNameEdit: true,
                calenderShow: true,
                filterToolBar: false,
                inviteButton: true,
                embedmeeting: true,
                lobbyChat: true,
                defaultTileView: true,
                customTutorial: true,
                saveUnClaimedRoom: true,
                showMuteDialog: false,
                roomOwnerReminderEmail: true,
                confirmUserToAutoHost: false,
                prejoinWithoutMic: false,
                canAllUserMakeHost: true,
                moderatorCanMakeHost: true,
                monitorHostTabChange: true,
                showE2eCheck: false,
                showRoomsListing: true,
                showLanguageDropdown: true,  // To show language dropdown in header (welcome and dashboard page)
                getRegionInfo: true,
                showSignInWithGoogle: false, // To enable/disable google sign in on live streaming dialog
                hostHangupNew: true, // For new host hangup flow (move other participants to third party server) 
                checkNatType: true, // For Symmetric NAT flow on box connect
                showJammingCapaility: false, // To show / Hide Jamming Capability in dashboard rooms.
                showSoftwareVersion: true, // To enable/disable software version
                autoDisableHybrid: true, // If hybrid is disconnect by user and unble to get any response by disconnect then menual trigger notification
                showPushSpinnerLoader: true, // To show push spinner loader
                hybridMsgTimer: 5000, // Message delay time in hybrid
                p2pMode: true, // To enable/disable P2P mode
                allowIframeOpen: false, // to show current url is opening in iframe
                webViewApp: false, // To enable/disable web view application functionality
        }
}

export const prejoinDetectDeviceEmitter = {
        SOC_RECEIVED: "S_RECEIVED", // socket received when any update made in device side
        DV_RECEIVED: "DV_RECEIVED", // will wait till new device not received after case 1
        SOC_RECEIVED_ERROR: "SOC_RECEIVED_ERROR", //socket received but having some error
        ERASE: "", // mark as empty
}

export const tourGuideActions = {
        USER_EMPTY: "",
        WITH_DEVICE: "WITH_DEVICE",
        WITHOUT_DEVICE: "WITHOUT_DEVICE",
        USER_HAS_BASIC_SUBSCRIPTION: "USER_HAS_BASIC_SUBSCRIPTION",
        USER_HAS_PREMIUM_SUBSCRIPTION: "USER_HAS_PREMIUM_SUBSCRIPTION",
        USER_RECONNECTED: "USER_RECONNECTED",
        USER_STARTED_MANUALLY: "USER_STARTED_MANUALLY",
}

export const tourGuideVisibilityActions = {
        TOUR_EMPTY: "",
        TOUR_WITH_DEVICE: "TOUR_WITH_DEVICE",
        TOUR_WITHOUT_DEVICE: "TOUR_WITHOUT_DEVICE",
}